(function() {
  'use strict';

  angular.module('eva2-angular').constant('TestRegex', {
    //the email regex is the same as backend in apollo, reference: http://emailregex.com/     
    //eslint-disable-next-line no-useless-escape
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i
  });
})();
